"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectTypes = exports.SelectStates = void 0;
var SelectTypes = {
  Normal: 'normal',
  Select: 'select',
  Checkbox: 'checkbox'
};
exports.SelectTypes = SelectTypes;
var SelectStates = {
  Default: 'default',
  Error: 'error'
};
exports.SelectStates = SelectStates;